import React, { useState } from "react";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export default function PasswordField({
  value,
  onChange,
  InputProps: customInputProps,
  label = "Password",
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      label={label}
      variant="outlined"
      type={showPassword ? "text" : "password"}
      value={value}
      onChange={onChange}
      fullWidth
      InputProps={{
        // Merge any custom props passed in
        ...customInputProps,
        endAdornment: (
          <>
            {customInputProps?.endAdornment}
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          </>
        ),
      }}
    />
  );
}
